import React, { useEffect, useState } from 'react'
import ProductForm from './ProductForm';
import { useAppData } from '../../../../../context/AppDataContext';
import { Autocomplete, TextField } from '@mui/material';
import productServices from '../productServices';

function SelectProduct({callBack, options, selectedProduct,setSelectedProduct}) {

  const {getProductList} = useAppData();

  const onCreateNew = (productId) =>{
    productServices.getById(productId).then(res=>{
      console.log(res.data);
      setSelectedProduct(res.data);
      getProductList()
      
    }).catch(error=>{
      console.log(error)
    })
  }

  
  

  return (

    <div className='row'>
      <div className='col-md-6'>
        <Autocomplete
            options={options}
            onChange={(event, newValue) => {
                setSelectedProduct(newValue);
            }}
            getOptionLabel={(product) => product.title}
            forcePopupIcon={false}
            className='bg-white'
            value={selectedProduct}
            renderInput={(params) => <TextField {...params} size="small" label="Select Product" variant="standard" /> } 
        />
      </div>
      <div className='col-md-6'>
        <span className='mx-2'>OR</span>
        <ProductForm callBackWithId={onCreateNew} />
      </div>
    </div>

  )
}

export default SelectProduct